export const veniceModels = {
    id: "venice",
    name: "Venice AI",
    api: "https://api.venice.ai/api/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://docs.venice.ai",
    env: ["VENICE_API_KEY"],
    models: {
        "qwen-2.5-coder-32b": {
            id: "qwen-2.5-coder-32b",
            name: "Qwen 2.5 Coder 32B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2025-06-14",
            last_updated: "2025-06-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 2,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "venice-uncensored": {
            id: "venice-uncensored",
            name: "Venice Uncensored 1.1",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2025-07-15",
            last_updated: "2025-07-15",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 2,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "deepseek-coder-v2-lite": {
            id: "deepseek-coder-v2-lite",
            name: "DeepSeek Coder V2 Lite",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-09",
            release_date: "2025-06-22",
            last_updated: "2025-06-22",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "dolphin-2.9.2-qwen2-72b": {
            id: "dolphin-2.9.2-qwen2-72b",
            name: "Dolphin 72B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2021-09",
            release_date: "2025-05-21",
            last_updated: "2025-05-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.7,
                output: 2.8,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen3-4b": {
            id: "qwen3-4b",
            name: "Venice Small",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-07",
            release_date: "2025-07-27",
            last_updated: "2025-07-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen-2.5-vl": {
            id: "qwen-2.5-vl",
            name: "Qwen 2.5 VL 72B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2025-06-09",
            last_updated: "2025-06-09",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.7,
                output: 2.8,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "llama-3.3-70b": {
            id: "llama-3.3-70b",
            name: "Llama 3.3 70B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-06-09",
            last_updated: "2025-06-09",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.7,
                output: 2.8,
            },
            limit: {
                context: 65536,
                output: 8192,
            },
        },
        "llama-3.1-405b": {
            id: "llama-3.1-405b",
            name: "Llama 3.1 405B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: false,
            knowledge: "2023-12",
            release_date: "2025-06-30",
            last_updated: "2025-06-30",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.5,
                output: 6,
            },
            limit: {
                context: 65536,
                output: 8192,
            },
        },
        "llama-3.2-3b": {
            id: "llama-3.2-3b",
            name: "Llama 3.2 3B",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2025-05-23",
            last_updated: "2025-05-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.15,
                output: 0.6,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "deepseek-r1-671b": {
            id: "deepseek-r1-671b",
            name: "DeepSeek R1 671B",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2025-06-05",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 3.5,
                output: 14,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "qwen-2.5-qwq-32b": {
            id: "qwen-2.5-qwq-32b",
            name: "Venice Reasoning",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2023-10",
            release_date: "2025-07-08",
            last_updated: "2025-07-08",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 2,
            },
            limit: {
                context: 32768,
                output: 8192,
            },
        },
        "qwen3-235b": {
            id: "qwen3-235b",
            name: "Venice Large",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-27",
            last_updated: "2025-07-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.5,
                output: 6,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
        "mistral-31-24b": {
            id: "mistral-31-24b",
            name: "Venice Medium",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2025-07-15",
            last_updated: "2025-07-15",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.5,
                output: 2,
            },
            limit: {
                context: 131072,
                output: 8192,
            },
        },
    },
};
export default veniceModels;
//# sourceMappingURL=venice.js.map